exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".colorpicker-field input {\n  height: 20px;\n  width: 20px;\n  margin: 0px;\n  padding: 0px;\n  cursor: pointer;\n  margin: 15px;\n  text-indent: 20px;\n}\n\n.color-picker .box {\n  margin: auto;\n  background: inherit;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/borneo/prod/borneo_app/src/app/shared/components/forms/colorpicker-field/colorpicker-field.component.css
// module id = ../../../../../src/app/shared/components/forms/colorpicker-field/colorpicker-field.component.css
// module chunks = main